import React, { Component } from 'react'
import TutorialCard from '../Components/TutorialCard'
import Navbar from '../Components/Navbar'
const title="Brain Booster"
const content = "Here in this portal you can play on your brain and boost its execution speed, problem solving ability and memory."
export default class About extends Component {
    render() {
        return (
            <>
                <header>
                    <Navbar />
                </header>
                <main className="main">
                    <TutorialCard title={title} content={content}></TutorialCard>
                </main>
            </>
        )
    }
}
